module.exports = __webpack_public_path__ + "img/Discord.ba4bb24d.png";